import { Button } from "@/components/ui/button";
import { Container } from "@/components/design-system/Container";
import { Heading } from "@/components/design-system/Heading";
import { Text } from "@/components/design-system/Text";
import { motion } from "framer-motion";
import { TeamBenefitsCa } from "@/components/coming-soon/TeamBenefitsCa";
import { GoalkeeperBenefitsCa } from "@/components/coming-soon/GoalkeeperBenefitsCa";
import { InterestFormModal } from "@/components/coming-soon/InterestFormModal";
import { ComingSoonHeader } from "@/components/coming-soon/ComingSoonHeader";
import { SocialIcons } from "@/components/coming-soon/SocialIcons";
import { useState } from "react";

const ComingSoonCa = () => {
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  const [partnershipModalOpen, setPartnershipModalOpen] = useState(false);

  return (
    <div className="min-h-screen">
      <ComingSoonHeader onContactClick={() => setNotificationModalOpen(true)} />

      <main className="pt-32 pb-20">
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto mb-20 px-4"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              className="mb-12"
            >
              <img 
                src="/LogoPorteroYa.svg"
                alt="PorteroYa Logo"
                width={128}
                height={128}
                className="h-32 w-32 mx-auto drop-shadow-xl"
              />
            </motion.div>
            <Heading 
              level="h1" 
              className="mb-8 sm:mb-16 text-4xl sm:text-5xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/80 leading-tight sm:leading-relaxed tracking-tight py-2"
            >
              Properament
            </Heading>
            <div className="space-y-6 sm:space-y-8">
              <div className="space-y-4 sm:space-y-6">
                <Text 
                  size="xl" 
                  className="text-gray-600 px-4 sm:px-8 max-w-2xl mx-auto"
                >
                  <span className="block text-xl sm:text-2xl font-bold text-primary mb-4 animate-pulse">
                    S'ha acabat improvisar a la porteria!
                  </span>
                  <span className="block text-base sm:text-lg leading-relaxed">
                    Connectem equips de futbol amateur amb porters apassionats que volen guanyar uns ingressos extres fent allò que els agrada. 
                    Converteix la teva passió pel futbol en una oportunitat per millorar el teu nivell i donar suport al teu equip.
                  </span>
                </Text>
                <Text className="text-gray-600 italic text-base sm:text-lg leading-relaxed px-4">
                  Perquè cada equip es mereix un autèntic guardià sota els pals.
                </Text>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8 sm:mt-12 px-4">
              <Button 
                size="lg"
                className="text-base px-8 py-6 h-auto w-full sm:w-auto"
                onClick={() => setNotificationModalOpen(true)}
              >
                Rebre Notificacions
              </Button>
              <Button 
                variant="secondary"
                size="lg"
                className="text-base px-8 py-6 h-auto w-full sm:w-auto"
                onClick={() => setPartnershipModalOpen(true)}
              >
                Convertir-se en Soci
              </Button>
            </div>
            
            {/* Social Icons - Hidden on mobile */}
            <div className="hidden sm:block mt-8">
              <SocialIcons />
            </div>
          </motion.div>

          <div className="space-y-12">
            <GoalkeeperBenefitsCa />
            <TeamBenefitsCa />
          </div>
        </Container>
      </main>

      <footer className="bg-white border-t py-8">
        <Container>
          <div className="text-center text-gray-600">
            {/* Social Icons - Visible only on mobile */}
            <div className="sm:hidden mb-6">
              <SocialIcons />
            </div>
            <p>© {new Date().getFullYear()} PorteroYa. Tots els drets reservats.</p>
            <div className="mt-4 space-x-4">
              <Button 
                variant="link" 
                className="hover:text-primary transition-colors"
                onClick={() => setNotificationModalOpen(true)}
              >
                Contacte
              </Button>
              <span>•</span>
              <Button 
                variant="link" 
                className="hover:text-primary transition-colors"
                onClick={() => setPartnershipModalOpen(true)}
              >
                Premsa
              </Button>
            </div>
          </div>
        </Container>
      </footer>

      <InterestFormModal
        isOpen={notificationModalOpen}
        onClose={() => setNotificationModalOpen(false)}
        type="notification"
        title="Mantén-te Informat"
      />

      <InterestFormModal
        isOpen={partnershipModalOpen}
        onClose={() => setPartnershipModalOpen(false)}
        type="partnership"
        title="Converteix-te en Soci"
      />
    </div>
  );
};

export default ComingSoonCa;